import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import Categories from '../../presentational/Categories';
import DocumentsHero from '../../presentational/Heros/Documents';


const categories = [
  {
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Claps', title: 'ERP Giriş', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 3, author: 'Hasan Murat Özen'
}

,
{
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Sidebar-Window', title: 'Satış Yönetimi', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 6, author: 'Azerhan Özen'
}

,
{
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Conference', title: 'Maliyet Muhasebesi', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 4, author: 'Azerhan Özen'
}

,
{
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Tie-4', title: 'Satınalma ve Stok', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 5, author: 'Hasan Murat Özen'
}

,
{
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Money-2', title: 'MRP', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 3, author: 'Hasan Murat Özen'
}

,
{
    url: '/DocumentCategory/15', iconClass: 'im im-icon-Timer-2', title: 'SQL', content: 'Take the first steps before diving deeply into our application. Learn how to setup your account and to get started the right way.', avatars: [ 'https://via.placeholder.com/250x250', 'https://via.placeholder.com/250x250'], documentsLength: 4, author: 'Hasan Murat Özen'
}
];
export default class Documents extends Component {
  render() {
    return(
      <Layout mainhero={<DocumentsHero />}>
        <Categories categories={categories} />
      </Layout>
    );
  }
};
